import { type MetaFunction } from '@remix-run/node'

import { type ExternalScriptsHandle } from 'remix-utils/external-scripts'

export const handle: ExternalScriptsHandle = {
	scripts: [
		{
			src: 'https://js.stripe.com/v3/buy-button.js',
			async: true,
			preload: true,
		},
	],
}

export const meta: MetaFunction = () => {
	return [
		{
			title: 'Kogia | Donate',
		},
	]
}

export default function Donate() {
	return (
		<>
			<div
				style={{
					backgroundImage:
						'url(https://images.squarespace-cdn.com/content/v1/5f27401564a09e77e7fe96c2/bd1619c7-6443-4c04-9086-b3dff9afc92b/Website+Mainpage.jpg)',
				}}
				className="flex flex-1 basis-1/2 items-center justify-center bg-cover bg-center"
			></div>
			<div className="flex flex-1 basis-1/2 flex-col items-center justify-center gap-4">
				{/* @ts-expect-error Stripe Buy Button */}
				<stripe-buy-button
					buy-button-id="buy_btn_1OqpX8Fn4CG0TqqfPTbYNQyd"
					publishable-key={ENV.STRIPE_PUBLISHABLE_KEY}
				>
					{/* @ts-expect-error Stripe Buy Button */}
				</stripe-buy-button>
			</div>
		</>
	)
}
